import { render, staticRenderFns } from "./MessageTextMentionEntityRegexpTypeSetupView.vue?vue&type=template&id=3c891b5a&scoped=true&"
import script from "./MessageTextMentionEntityRegexpTypeSetupView.vue?vue&type=script&lang=ts&"
export * from "./MessageTextMentionEntityRegexpTypeSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c891b5a",
  null
  
)

export default component.exports